import { render, staticRenderFns } from "./FilterDapp.vue?vue&type=template&id=0f65b750&scoped=true"
import script from "./FilterDapp.vue?vue&type=script&lang=ts"
export * from "./FilterDapp.vue?vue&type=script&lang=ts"
import style0 from "./FilterDapp.vue?vue&type=style&index=0&id=0f65b750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f65b750",
  null
  
)

export default component.exports